import { useCallback, useEffect, useState } from 'react';
import { getSmartDefaults } from '../../../../../utils/smartDefaults';
import { fetchProductDefaultSettings } from './productDefaultSettingsApi';

export const useProductDefaultSettings = (token) => {
    const [defaults, setDefaults] = useState(() => getSmartDefaults());
    const [loading, setLoading] = useState(Boolean(token));
    const [error, setError] = useState(null);

    const load = useCallback(
        async ({ force = false } = {}) => {
            if (!token) {
                setDefaults(getSmartDefaults());
                setLoading(false);
                setError(null);
                return { success: true, defaults: getSmartDefaults() };
            }

            setLoading(true);
            const result = await fetchProductDefaultSettings(token, { force });
            setDefaults(result.defaults);
            setError(result.success ? null : result.message);
            setLoading(false);
            return result;
        },
        [token]
    );

    useEffect(() => {
        load();
    }, [load]);

    return {
        defaults,
        loading,
        error,
        reload: () => load({ force: true }),
        setDefaults,
    };
};
